import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Imprimer — imprimante duotone */
export const PrintIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Feuille sortie menthe */}
      <rect x="6.5" y="14" width="11" height="6.5" rx="1" fill="var(--equiply-icon-bg)" fillOpacity="0.7" />
      {/* Corps imprimante */}
      <path d="M6 9h12a2 2 0 0 1 2 2v5a1 1 0 0 1-1 1h-1.5M6 17H4.5a1 1 0 0 1-1-1v-5a2 2 0 0 1 2-2z" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      {/* Tête de l'imprimante */}
      <path d="M7 9V4.5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1V9" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round" />
      {/* Sortie papier */}
      <rect x="6.5" y="14" width="11" height="6.5" rx="1" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Voyant */}
      <circle cx="17" cy="12.5" r="0.7" fill="var(--equiply-icon-fg)" />
    </svg>
  ),
);
PrintIcon.displayName = "PrintIcon";
